import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Search from './../components/Search'

import BooksMiddleware from './../modules/books/middleware'

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    changeSearchTerm: (searchTerm) => BooksMiddleware.changeSearchTerm(searchTerm)
  }, dispatch)
}

class SearchContainer extends Component {
  render () {
    return (
      <Search changeSearchTerm={this.props.changeSearchTerm} />
    )
  }
}

export default connect(null, mapDispatchToProps)(SearchContainer)



// WEBPACK FOOTER //
// ./src/containers/BooksSearchContainer.js